/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  BeeConfigsRequest,
  ClientConfigurationDTO,
  ClientConfigurationRequest,
  CreateOrUpdateBeeConfigsPathParameters,
  CreateOrUpdateClientConfigurationPathParameters,
  CreateOrUpdatePathParameters,
  CreateOrUpdateSystemConfigurationPathParameters,
  DeleteClientConfigurationPathParameters,
  Get2PathParameters,
  GetClientConfigurationPathParameters,
  GetSystemConfigurationPathParameters,
  GetTypekitJsonPathParameters,
  JsonNode,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getClientConfiguration = () => {
  /**
 * Create or update configuration for client

Required authority: PERM_THEME_WRITE
 */
  const createOrUpdate = ({ clientId }: CreateOrUpdatePathParameters, jsonNode: JsonNode) => {
    return customInstance<JsonNode>({
      url: `/api/clients/${clientId}/theme`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: jsonNode,
    });
  };
  /**
 * Get configuration for a client

Required authority: PERM_CLIENT_READ
 */
  const getClientConfiguration = ({
    clientId,
    configKey,
  }: GetClientConfigurationPathParameters) => {
    return customInstance<ClientConfigurationDTO>({
      url: `/api/clients/${clientId}/configuration/${configKey}`,
      method: "GET",
    });
  };
  /**
 * Create or update configuration for a client

Required authority: PERM_CLIENT_WRITE
 */
  const createOrUpdateClientConfiguration = (
    { clientId, configKey }: CreateOrUpdateClientConfigurationPathParameters,
    clientConfigurationRequest: ClientConfigurationRequest,
  ) => {
    return customInstance<ClientConfigurationDTO>({
      url: `/api/clients/${clientId}/configuration/${configKey}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: clientConfigurationRequest,
    });
  };
  /**
 * Delete Configuration for a client

Required authority: PERM_CLIENT_WRITE
 */
  const deleteClientConfiguration = ({
    clientId,
    configKey,
  }: DeleteClientConfigurationPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/configuration/${configKey}`,
      method: "DELETE",
    });
  };
  /**
 * Create or update both bee-config and brand-style-config atomically

Required authority: PERM_THEME_WRITE
 */
  const createOrUpdateBeeConfigs = (
    { clientId }: CreateOrUpdateBeeConfigsPathParameters,
    beeConfigsRequest: BeeConfigsRequest,
  ) => {
    return customInstance<JsonNode>({
      url: `/api/clients/${clientId}/bee-configs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: beeConfigsRequest,
    });
  };
  /**
 * Get system-wide configuration

Required authority: PERM_CLIENT_READ
 */
  const getSystemConfiguration = ({ configKey }: GetSystemConfigurationPathParameters) => {
    return customInstance<ClientConfigurationDTO>({
      url: `/api/clients/configuration/${configKey}`,
      method: "GET",
    });
  };
  /**
 * Create or update system-wide configuration

Required authority: PERM_SUPER_ADMIN
 */
  const createOrUpdateSystemConfiguration = (
    { configKey }: CreateOrUpdateSystemConfigurationPathParameters,
    clientConfigurationRequest: ClientConfigurationRequest,
  ) => {
    return customInstance<ClientConfigurationDTO>({
      url: `/api/clients/configuration/${configKey}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: clientConfigurationRequest,
    });
  };
  /**
 * Get configuration for client

Required authority: PERM_THEME_READ
 */
  const get2 = ({ clientId, config }: Get2PathParameters) => {
    return customInstance<JsonNode>({ url: `/api/clients/${clientId}/${config}`, method: "GET" });
  };
  /**
 * Get typekit JSON

Required authority: PERM_THEME_WRITE
 */
  const getTypekitJson = ({ clientId, typekitId }: GetTypekitJsonPathParameters) => {
    return customInstance<string>({
      url: `/api/clients/${clientId}/themes/typekit/${typekitId}`,
      method: "GET",
    });
  };
  return {
    createOrUpdate,
    getClientConfiguration,
    createOrUpdateClientConfiguration,
    deleteClientConfiguration,
    createOrUpdateBeeConfigs,
    getSystemConfiguration,
    createOrUpdateSystemConfiguration,
    get2,
    getTypekitJson,
  };
};
export type CreateOrUpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["createOrUpdate"]>>
>;
export type GetClientConfigurationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["getClientConfiguration"]>>
>;
export type CreateOrUpdateClientConfigurationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getClientConfiguration>["createOrUpdateClientConfiguration"]>
  >
>;
export type DeleteClientConfigurationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["deleteClientConfiguration"]>>
>;
export type CreateOrUpdateBeeConfigsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["createOrUpdateBeeConfigs"]>>
>;
export type GetSystemConfigurationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["getSystemConfiguration"]>>
>;
export type CreateOrUpdateSystemConfigurationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getClientConfiguration>["createOrUpdateSystemConfiguration"]>
  >
>;
export type Get2Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["get2"]>>
>;
export type GetTypekitJsonResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClientConfiguration>["getTypekitJson"]>>
>;
